import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import NavBar from './ui/nav/nav';
import HomePage from './pages/home';
import NewsPage from './pages/news';
import ReadNewsPage from './pages/read-news'
import AboutPage from './pages/about';
import ProjectPage from './pages/projects';
import TeamPage from './pages/team';
import ContactPage from './pages/contact';
import PageNotFound from './pages/404';

import Footer from './ui/footer/footer';

function App() {
  return (
    <Router>
      <div className="App">
        <NavBar/>
        <Switch>
          <Route path="/" exact component={HomePage}/>
          <Route path="/news" exact component={NewsPage} />
          <Route path="/news/:id" exact component={ReadNewsPage} />
          <Route path="/about" exact component={AboutPage} />
          <Route path="/projects" exact component={ProjectPage} />
          <Route path="/team" exact component={TeamPage} />
          <Route path="/contact" exact component={ContactPage} />
          <Route path="*" component={PageNotFound}></Route>
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
